import React, { useEffect, useState } from 'react';
import { useAuth0 } from "@auth0/auth0-react";
import { DataGridPro, LicenseInfo } from '@mui/x-data-grid-pro';
import Box from '@mui/material/Box';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import { IconButton } from '@mui/material';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import LinearProgress from '@mui/material/LinearProgress';
import ReceiptMappingDialog from '../dialog/ReceiptMappingDialog';

LicenseInfo.setLicenseKey('17ca2e8476fa658618680f9f135dbc81T1JERVI6MzU2MTYsRVhQSVJZPTE4NzMzODQyMDIwMDAsS0VZVkVSU0lPTj0x',);


export default function ReceiptOverviewDataGrid() {
    const { isAuthenticated } = useAuth0();
    const [rows, setRows] = React.useState([])
    const [contextMenu, setContextMenu] = useState(null);
    const [receiptMapping, setReceiptMapping] = useState(false);

    const columns = [
            {field: 'receipt_name',         headerName: 'Receipt Name',     width: 160},
            {field: 'camera_format',        headerName: 'Camera Format',    width: 160},
            {field: 'result',               headerName: 'Result',           width: 150},
            {field: 'pipeline',             headerName: 'Pipeline',         width: 500},
            {field: 'conditions',           headerName: 'Special conditions',   width: 180}
        ];

    const dummyData = [
        { id: 1, receipt_name: 'ALFOGS', camera_format: 'ALFOGS', result: 'RESULT 1', pipeline: 'ARRIRAW1 -> Reframe1 -> CDL1 -> LUT1 -> BurnIn4 -> RESULT1', conditions: 'N/A', nodelist: [
            { id: 1, name: 'ARRIRAW1', values: [
                                                {key: 'ASA', setting: '1', custom: ''},
                                                {key: 'ASAPreset', setting: '1', custom: ''},
                                                {key: 'ColorSpace', setting: '1', custom: ''},
                                                {key: 'Sharpen', setting: '1', custom: ''},
                                                {key: 'Temp', setting: '1', custom: ''},
                                                {key: 'TempPreset', setting: '1', custom: ''},
                                                {key: 'Tint', setting: '1', custom: ''}] },
            { id: 2, name: 'Reframe1', values: [
                                                {key: 'Aspect', setting: '1', custom: ''},
                                                {key: 'AspectPreset', setting: '1', custom: ''},
                                                {key: 'ExtraZoom', setting: '1', custom: ''},
                                                {key: 'FlipXOn', setting: '1', custom: ''},
                                                {key: 'FlipYOn', setting: '1', custom: ''},
                                                {key: 'LetterBox', setting: '1', custom: ''},
                                                {key: 'LetterBoxPreset', setting: '1', custom: ''},
                                                {key: 'Preset', setting: '1', custom: ''},
                                                {key: 'Tilt', setting: '1', custom: ''},
                                                {key: 'height', setting: '1', custom: ''},
                                                {key: 'width', setting: '1', custom: ''}, ] },
            { id: 3, name: 'CDL1', values: [
                                                {key: 'BOffset', setting: '1', custom: ''},
                                                {key: 'BPower', setting: '1', custom: ''},
                                                {key: 'BSlope', setting: '1', custom: ''},
                                                {key: 'GOffset', setting: '1', custom: ''},
                                                {key: 'GPower', setting: '1', custom: ''},
                                                {key: 'GSlope', setting: '1', custom: ''},
                                                {key: 'PosX', setting: '1', custom: ''},
                                                {key: 'PosY', setting: '1', custom: ''},
                                                {key: 'ROffset', setting: '1', custom: ''},
                                                {key: 'RPower', setting: '1', custom: ''},
                                                {key: 'RSlope', setting: '1', custom: ''},
                                                {key: 'Saturation', setting: '1', custom: ''},]  },
            { id: 4, name: 'LUT1', values: [
                                                {key: 'Interpolation', setting: '1', custom: ''},
                                                {key: 'Lut', setting: '1', custom: ''} ]  },
            { id: 5, name: 'BurnIn4', values: [
                                                {key: 'LetterBoxAspect', setting: '1', custom: ''},
                                                {key: 'LetterBoxBalance 15', setting: '1', custom: ''}]},] },
        { id: 2, receipt_name: 'ALFOGS', camera_format: 'ALFOGS', result: 'RESULT 2', pipeline: 'ARRIRAW2 -> RESULT2', conditions: 'N/A', nodelist: [
            { id: 1, name: 'ARRIRAW2', values: [
                                                {key: 'ASA', setting: '1', custom: ''},
                                                {key: 'ASAPreset', setting: '1', custom: ''},
                                                {key: 'ColorSpace', setting: '1', custom: ''},
                                                {key: 'Sharpen', setting: '1', custom: ''},
                                                {key: 'Temp', setting: '1', custom: ''},
                                                {key: 'TempPreset', setting: '1', custom: ''},
                                                {key: 'Tint', setting: '1', custom: ''}] },]},
        { id: 3, receipt_name: 'ALFOGA', camera_format: 'ALFOGA', result: 'RESULT 1', pipeline: 'ARRIRAW1 -> Reframe1 -> CDL1 -> LUT1 -> BurnIn4 -> RESULT1', conditions: 'N/A',nodelist: [
            { id: 1, name: 'ARRIRAW1', values: [
                                                {key: 'ASA', setting: '1', custom: ''},
                                                {key: 'ASAPreset', setting: '1', custom: ''},
                                                {key: 'ColorSpace', setting: '1', custom: ''},
                                                {key: 'Sharpen', setting: '1', custom: ''},
                                                {key: 'Temp', setting: '1', custom: ''},
                                                {key: 'TempPreset', setting: '1', custom: ''},
                                                {key: 'Tint', setting: '1', custom: ''}] },
            { id: 2, name: 'Reframe1', values: [
                                                {key: 'Aspect', setting: '1', custom: ''},
                                                {key: 'AspectPreset', setting: '1', custom: ''},
                                                {key: 'ExtraZoom', setting: '1', custom: ''},
                                                {key: 'FlipXOn', setting: '1', custom: ''},
                                                {key: 'FlipYOn', setting: '1', custom: ''},
                                                {key: 'LetterBox', setting: '1', custom: ''},
                                                {key: 'LetterBoxPreset', setting: '1', custom: ''},
                                                {key: 'Preset', setting: '1', custom: ''},
                                                {key: 'Tilt', setting: '1', custom: ''},
                                                {key: 'height', setting: '1', custom: ''},
                                                {key: 'width', setting: '1', custom: ''}, ] },
            { id: 3, name: 'CDL1', values: [
                                                {key: 'BOffset', setting: '1', custom: ''},
                                                {key: 'BPower', setting: '1', custom: ''},
                                                {key: 'BSlope', setting: '1', custom: ''},
                                                {key: 'GOffset', setting: '1', custom: ''},
                                                {key: 'GPower', setting: '1', custom: ''},
                                                {key: 'GSlope', setting: '1', custom: ''},
                                                {key: 'PosX', setting: '1', custom: ''},
                                                {key: 'PosY', setting: '1', custom: ''},
                                                {key: 'ROffset', setting: '1', custom: ''},
                                                {key: 'RPower', setting: '1', custom: ''},
                                                {key: 'RSlope', setting: '1', custom: ''},
                                                {key: 'Saturation', setting: '1', custom: ''},]  },
            { id: 4, name: 'LUT1', values: [
                                                {key: 'Interpolation', setting: '1', custom: ''},
                                                {key: 'Lut', setting: '1', custom: ''} ]  },
            { id: 5, name: 'BurnIn4', values: [
                                                {key: 'LetterBoxAspect', setting: '1', custom: ''},
                                                {key: 'LetterBoxBalance 15', setting: '1', custom: ''}]},] },
        { id: 4, receipt_name: 'ALFOGA', camera_format: 'ALFOGA', result: 'RESULT 2', pipeline: 'ARRIRAW2 -> RESULT2', conditions: 'N/A', nodelist: [
            { id: 1, name: 'ARRIRAW2', values: [
                                                {key: 'ASA', setting: '1', custom: ''},
                                                {key: 'ASAPreset', setting: '1', custom: ''},
                                                {key: 'ColorSpace', setting: '1', custom: ''},
                                                {key: 'Sharpen', setting: '1', custom: ''},
                                                {key: 'Temp', setting: '1', custom: ''},
                                                {key: 'TempPreset', setting: '1', custom: ''},
                                                {key: 'Tint', setting: '1', custom: ''}] },]},
        { id: 5, receipt_name: 'FILMSCAN', camera_format: 'FILMSCAN', result: 'RESULT 1', pipeline: 'Reframe1 -> ColorConv1 -> CDL1 -> LUT1 -> BurnIn4 -> RESULT1', conditions: 'N/A', nodelist: [
            { id: 1, name: 'Reframe1', values: [
                                                {key: 'Aspect', setting: '1', custom: ''},
                                                {key: 'AspectPreset', setting: '1', custom: ''},
                                                {key: 'ExtraZoom', setting: '1', custom: ''},
                                                {key: 'FlipXOn', setting: '1', custom: ''},
                                                {key: 'FlipYOn', setting: '1', custom: ''},
                                                {key: 'LetterBox', setting: '1', custom: ''},
                                                {key: 'LetterBoxPreset', setting: '1', custom: ''},
                                                {key: 'Preset', setting: '1', custom: ''},
                                                {key: 'Tilt', setting: '1', custom: ''},
                                                {key: 'height', setting: '1', custom: ''},
                                                {key: 'width', setting: '1', custom: ''}, ] },
            { id: 3, name: 'ColorConv1', values: [
                                                {key: 'InputColorName', setting: '1', custom: ''},
                                                {key: 'InputCurveName', setting: '1', custom: ''},
                                                {key: 'OutputColorName', setting: '1', custom: ''},
                                                {key: 'OutputCurveName', setting: '1', custom: ''},]  },
            { id: 4, name: 'CDL1', values: [
                                                {key: 'BOffset', setting: '1', custom: ''},
                                                {key: 'BPower', setting: '1', custom: ''},
                                                {key: 'BSlope', setting: '1', custom: ''},
                                                {key: 'GOffset', setting: '1', custom: ''},
                                                {key: 'GPower', setting: '1', custom: ''},
                                                {key: 'GSlope', setting: '1', custom: ''},
                                                {key: 'PosX', setting: '1', custom: ''},
                                                {key: 'PosY', setting: '1', custom: ''},
                                                {key: 'ROffset', setting: '1', custom: ''},
                                                {key: 'RPower', setting: '1', custom: ''},
                                                {key: 'RSlope', setting: '1', custom: ''},
                                                {key: 'Saturation', setting: '1', custom: ''},]  },
            { id: 5, name: 'LUT1', values: [
                                                {key: 'Interpolation', setting: '1', custom: ''},
                                                {key: 'Lut', setting: '1', custom: ''} ]  },
            { id: 6, name: 'BurnIn4', values: [
                                                {key: 'LetterBoxAspect', setting: '1', custom: ''},
                                                {key: 'LetterBoxBalance 15', setting: '1', custom: ''}]},
        ]},
        { id: 6, receipt_name: 'FILMSCAN', camera_format: 'FILMSCAN', result: 'RESULT 2', pipeline: 'ColorConv2 -> RESULT2', conditions: 'N/A', nodelist: [
            { id: 1, name: 'ColorConv2', values: [
                                                {key: 'InputColorName', setting: '1', custom: ''},
                                                {key: 'InputCurveName', setting: '1', custom: ''},
                                                {key: 'OutputColorName', setting: '1', custom: ''},
                                                {key: 'OutputCurveName', setting: '1', custom: ''}]}]},
    ];

    const [selectedNodeList, setSelectedNodeList] = useState(dummyData[0].nodelist);

    const handleRowContextMenu = (event, row) => {
        event.preventDefault();
        setContextMenu(
            contextMenu === null
                ? {
                      mouseX: event.clientX - 2,
                      mouseY: event.clientY - 4,
                      row,
                  }
                : null,
        );
    };

    const handleRowDoubleClick = (params) => {
        setSelectedNodeList(params.row.nodelist);
        setReceiptMapping(true);
    };
    
    const handleReceiptMappingClose = () => {
        setReceiptMapping(false);
        setSelectedNodeList(dummyData[0].nodelist);
    };

    const handleClose = () => {
        setContextMenu(null);
    };

    const handleMenuItemClick = (action) => {
        handleClose();
    };


    useEffect(() => {
        isAuthenticated && (() => {
            setRows(dummyData)
        })()
    }, [isAuthenticated])

    return (
        <React.Fragment>
            <DataGridPro 
                sx={{
                    backgroundColor: '#101010', // Change the background color of the data grid
                    borderColor: '#122218',
                    '& .MuiDataGrid-root': {
                        cursor: 'pointer', // Change the cursor to pointer when hovering over the data grid
                    },
                    '& .MuiDataGrid-cell:hover': {
                        color: 'rgb(76, 146, 107)',
                    },
                    '& .MuiDataGrid-columnSeparator': {
                        borderColor: 'green', // Make the separator green
                        borderWidth: '2px', // Set the thickness of the separator
                        visibility: 'visible', // Ensure the separator is always visible
                        '&:hover': {
                            borderColor: 'rgb(76, 146, 107)', // Ensure the separator stays green on hover
                        },
                    },
                    '& .MuiDataGrid-columnHeaders': {
                        backgroundColor: '#101010', // Change the column header background to black
                    },
                    '& .MuiDataGrid-columnHeader': {
                        fontSize: '14px', // Customize the font size of the column headers
                        color: 'white', // Change the column header color to white
                        fontWeight: 'bold', // Make the column header text bold
                        borderBottom: 'None', // Change the bottom line color of the column headers
                    },
                    '& .MuiDataGrid-row': {
                        border: 'none', // Remove the row separator lines
                    },
                    '& .MuiDataGrid-rowCount': {
                        color: 'white', // Change the background color of the selected row
                    },
                    '& .MuiDataGrid-selectedRowCount': {
                        color: 'white', // Change the font color of the selected row count
                    },
                    '& .MuiDataGrid-cell': {
                        border: 'none', // Remove the cell separator lines
                        color: 'white', // Change the font color of the cells
                        fontSize: '13px', // Make the cell text smaller
                    },
                    '& .MuiDataGrid-row:nth-of-type(odd)': {
                        backgroundColor: '#161618', // Change the background color of odd rows
                    },
                    '& .MuiDataGrid-row:nth-of-type(even)': {
                        backgroundColor: '#202020', // Change the background color of even rows
                    },
                    '& .MuiDataGrid-row:hover': {
                        backgroundColor: 'rgba(76, 146, 107, 0.1)', // Change the hover color of the row to light green with reduced opacity
                    },
                    '& .MuiDataGrid-cell--withRenderer': {
                        '& .MuiCheckbox-root': {
                            color: 'white', // Change the color of the checkbox
                            transform: 'scale(0.7)', // Make the checkbox smaller
                            '& .MuiSvgIcon-root': {
                                borderRadius: '50%', // Make the checkbox a circle
                            },
                            '&.Mui-checked': {
                                color: '#54a277', // Change the color of the selected checkbox to green
                            },
                        },
                    },
                    '& .MuiDataGrid-columnHeaderCheckbox': {
                        '& .MuiCheckbox-root': {
                            color: 'white', // Change the color of the checkbox in the column header
                            transform: 'scale(0.8)', // Make the checkbox smaller in the column header
                            '& .MuiSvgIcon-root': {
                                borderRadius: '50%', // Make the checkbox a circle in the column header
                            },
                            '&.Mui-checked': {
                                color: '#54a277', // Change the color of the selected checkbox to green in the column header
                            },
                        },
                    },
                }}
                rows={rows}
                columns={columns}
                onRowDoubleClick={handleRowDoubleClick}
                pageSize={4}
                rowHeight={50} // Adjust the row height to make rows more compact
            />
            <ReceiptMappingDialog open={receiptMapping} onClose={handleReceiptMappingClose} nodeList={selectedNodeList}/>
            {contextMenu !== null && (
                <Menu
                    keepMounted
                    open={contextMenu.mouseY !== null}
                    onClose={handleClose}
                    anchorReference="anchorPosition"
                    anchorPosition={
                        contextMenu !== null
                            ? { top: contextMenu.mouseY, left: contextMenu.mouseX }
                            : undefined
                    }
                >
                    <MenuItem onClick={() => handleMenuItemClick('Edit')}>Edit</MenuItem>
                    <MenuItem onClick={() => handleMenuItemClick('Delete')}>Delete</MenuItem>
                </Menu>
            )}
        </React.Fragment>
    )
 }
